import React from 'react'
import {createBrowserRouter, Outlet, RouterProvider} from 'react-router-dom'
import PageError from '../../pages/PageError'
import PageIndex from '../../pages/PageIndex'
import PageLogin from '../../pages/PageLogin'
import AppAuthTokenProvider from './AppTokenProvider'

//warning - internal from react router
import type {Router} from '@remix-run/router'
import PageReportDetail from '../../pages/PageReportDetail'
import {useTenantID} from './AppTenantID'

export interface eqxAppConfigRoutes {
    routes: eqxAppConfigRoute[]
    loginPath: string
    disableAuth?: boolean
}
export interface eqxAppConfigRoute {
    path: string
    component?: any
    exact?: boolean
    children?: eqxAppConfigRoute[]
    element?: React.ReactNode
    errorElement?: React.ReactNode
}
interface AppRouterContext {
    router: Router
    navigateToLogin: () => any
    navigate: (path: string) => any
    loginPath: string
}

const RouteController = (props: any) => {
    return <Outlet />
}
const RouteControllerRequireAuth = (props: any) => {
    return (
        <AppAuthTokenProvider>
            <Outlet />
        </AppAuthTokenProvider>
    )
}

const routerContext = React.createContext<AppRouterContext | undefined>(undefined)
const RouterContextProvider = routerContext.Provider
const AppRouter = () => {
    const tenantID = useTenantID()
    const config = {
        disableAuth: false,
        routes: [
            {
                element: <RouteController />,
                errorElement: <PageError />,
                children: [
                    {
                        path: '/',
                        element: <RouteControllerRequireAuth />,
                        children: [
                            {
                                path: '/',
                                element: <PageIndex />,
                            },
                            {
                                path: '/reports/:id',
                                element: <PageReportDetail />,
                            },
                        ],
                    },
                    {
                        path: '/login',
                        element: <PageLogin />,
                    },
                ],
            },
        ],
        loginPath: '/login',
    }
    const options = {
        basename: `/${tenantID}`,
    }

    const router = createBrowserRouter(config.routes, options)
    const AppRouter = {
        router,
        navigate: (url: string) => {
            router.navigate(url)
        },
        navigateToLogin: () => {
            router.navigate(config.loginPath)
        },
        loginPath: config.loginPath,
    }
    return (
        <RouterContextProvider value={AppRouter}>
            <RouterProvider router={router} />
        </RouterContextProvider>
    )
}
const useRouterContext = () => {
    const context = React.useContext(routerContext)
    if (context === undefined) {
        throw new Error('useRouterContext must be used within a AppTenantProvider')
    }
    return context
}

export {AppRouter as default, routerContext, useRouterContext, type AppRouterContext}
